import React from 'react';
import { StopTravelStatus } from '../../redux/type';
import classNames from 'classnames';
type SpotProps = {
  travelStatus: StopTravelStatus;
  time: number;
  isFirstOrLast: boolean;
  isLast: boolean;
  handleClick: AnyFunc;
};
const SpotComp = (props: SpotProps) => {
  const { travelStatus, time, isFirstOrLast, isLast, handleClick } = props;
  return (
    <i
      className={classNames('spot', {
        isStaying: travelStatus === StopTravelStatus.STAY && !isFirstOrLast,
        isInit: travelStatus === StopTravelStatus.INIT,
        isDepart:
          travelStatus === StopTravelStatus.DEPART ||
          (isLast && travelStatus === StopTravelStatus.STAY),
        isSkip: travelStatus === StopTravelStatus.SKIP,
      })}
      onClick={handleClick}
    />
  );
};

export default React.memo(SpotComp);
